
import React, { useEffect } from 'react';
import ProBg from "./proBg.jpg"
const Gpipe = () => {
    useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when this page loads
  }, []);
  return (
    <div>
      <section
        className="featured-job-area section-padding30 section-bg2"
        style={{
        backgroundImage: `url(${ProBg})`,  backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',  // Adjust the height here
        }}
      >
        <div className="container">
          <div className="row justify-content">
            <div className="col-xl-7 col-lg-9 col-md-10 col-sm-12">
              {/* Section Title */}
              <div className="section-tittle text-left mb-80">
                <h2>G Pipe </h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {/* Add content here */}
          </div>
        </div>
      </section>

      <section className="about-low-area section-padding2" style={{ marginTop: '-50px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-10">
              <div className="about-caption mb-11">
                <div className="section-tittle mb-11">
                  {/* <span>About Al Hadeed Steel</span> */}
                  {/* <h2>Building the Future with Strength and Durability</h2> */}
                </div>
                <p style={{lineHeight:"2.4"}}>
<h3>Galvanized Piping</h3>
<p>
In the early 20th century, galvanized piping replaced cast iron and lead in cold-water plumbing systems. Over time, this type of piping deteriorates <strong>from the inside out</strong>, accumulating deposits or plaques that can lead to reduced water pressure and eventual pipe failure. These plaques may break loose, introducing visible impurities into the water and imparting a faint metallic taste.
</p>
<p>
The average lifespan of galvanized piping is approximately 70 years, though this can vary depending on regional factors such as water supply impurities and proximity to electrical grids. Electrical currents traveling through interior piping can accelerate <strong>corrosion processes</strong>, further shortening its longevity. Durability also depends on the zinc coating applied during the galvanizing process, which varies from G40 to G210, and whether the pipe was coated internally and externally or only externally.
</p>
<p>
Since the end of World War II, copper and plastic piping have largely supplanted galvanized pipes for indoor drinking water applications. However, galvanized steel remains a preferred choice for outdoor uses requiring its <strong>superior mechanical strength</strong>, such as garden faucets and external fixtures. This gives some merit to the urban myth that water from outdoor faucets is less pure, although the impurities (iron, zinc, and calcium) are generally harmless.
</p>
<p>
The presence of galvanized piping often reduces the appraised value of homes, as the pipes pose a risk of failure, potentially leading to water damage. Replacement is often necessary to maintain the longevity of the property, especially in jurisdictions that mandate replacement before the sale of a home. A cost-effective alternative to replacement is lining existing galvanized piping with <strong>epoxy resin</strong>, which extends its lifespan.
</p>

<h3>Galvanized Construction Steel</h3>
<p>
Galvanized construction steel is the most widespread application of the galvanizing process, with hundreds of thousands of tonnes processed annually on a global scale. In most developed countries, major cities host multiple galvanizing facilities, ensuring steel products are treated for <strong>enhanced durability</strong> and corrosion resistance. Commonly galvanized items include street furniture, building frameworks, balconies, verandahs, staircases, ladders, and walkways.
</p>
<p>
Additionally, SGCC hot-dip galvanized steel is widely utilized for manufacturing steel frames, serving as a foundational material for constructing steel-framed buildings. The protective zinc coating significantly increases the material’s <strong>resilience</strong>, making it ideal for outdoor and structural applications.
</p>

<h3>KB Steel Group</h3>
<p>
At KB STEEL Group, we operate with a commitment to <strong>excellence and precision</strong>, as evidenced by our ISO 9001:2000 certification for Quality Management. Our dedication to teamwork and stakeholder growth drives our pursuit of innovation and continuous improvement. While fostering a <strong>unified corporate culture</strong>, we aim to elevate the performance standards of all business activities, ensuring sustainability and customer satisfaction.
</p>

 </p>
                
              </div>
            </div>
          </div>
               
        </div>
      </section>
    </div>
  );
}

export default Gpipe;
